<script>
  import { _ } from 'svelte-i18n'

  import Card from '/Atoms/Card'

  const linkTelegram = $_("widgets.little_cards.card1.url")
  const linkNewsletter = $_("widgets.little_cards.card2.url")

</script>

<div class="container">
    <Card 
        nohole 
        flow 
        link={{ to: linkTelegram}}
        bgColorKey="purewhite"
      >
      <span class="content">
        {$_("widgets.little_cards.card1.title")}
      </span>
    </Card>
  
    <Card 
        nohole 
        flow 
        link={{ to: linkNewsletter}}
        bgColorKey="purewhite"
      >
      <span class="content">
        {$_("widgets.little_cards.card2.title")}
      </span>
    </Card>
</div>

<style lang="scss">
  .container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    place-items: stretch;
    gap: 20px;
    @include media-small {
      gap: 15px;
    }
  }

  .content {
    text-align: center;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    @include typo-serif-text-28;
  }
</style>